import React from "react";
import {Modal} from "react-bootstrap";
import {OrderEditForm} from "./OrderEditForm";
import {EditDialogHeader} from "../../../../_metronic/_partials/controls/edit-dialog-header/EditDialogHeader";
import {updateStatus} from "../crud/orderCrud";
import {useOrdersUIContext} from "../OrdersUIContext";

export function OrderEdit({show, onHide, onSave}) {

    const ordersUIContext = useOrdersUIContext();

    // server request for saving customer
    const handleSave = (values) => {

        const formData = new FormData();
        formData.append('order_id', ordersUIContext.id);
        formData.append('status_id', values.status_id);
        updateStatus(formData)
            .then(() => {
                onSave();
            })
    };

    return (
        <>
            <Modal
                size="lg"
                show={show}
                onHide={onHide}
                aria-labelledby="example-modal-sizes-title-lg"
            >
                <EditDialogHeader id={ordersUIContext.id} item={`سفارش شماره`} name={ordersUIContext.id}/>
                <OrderEditForm
                    handleSave={handleSave}
                    formValues={ordersUIContext.order}
                    onHide={onHide}
                    statuses={ordersUIContext.statuses}
                />
            </Modal>
        </>
    );
}
